module.exports = __webpack_public_path__ + "static/media/video-amount-icon.14b48bb7.svg";